import "moment-duration-format"; // Don't remove this line, it is needed to register the moment.js plugin
import "ag-grid-enterprise";
import "widgets/variables.css";
import "./global.scss"; // Keep this line as high as possible so that CSS modules always overwrite it.

import { LicenseManager } from "ag-grid-enterprise";
import { createRoot } from "react-dom/client";

import { Selector } from "./Selector.tsx";

LicenseManager.setLicenseKey(
  "Using_this_{AG_Grid}_Enterprise_key_{AG-083314}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Genedata_AG}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Genedata_Selector}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Genedata_Selector}_need_to_be_licensed___{Genedata_Selector}_has_been_granted_a_Deployment_License_Add-on_for_{35}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{30_August_2026}____[v3]_[01]_MTc4ODA0NDQwMDAwMA==c15185526a66c8d60158ca3765ee3f55",
);

const container = document.getElementById("root")!;
const root = createRoot(container);
root.render(<Selector />);
